import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
// axios.defaults.withCredentials = true

// axios.defaults.baseURL = 'http://164.68.105.150:3001'

export const localhost = 'localhost'
export const stageIp = '51.89.97.15'
export const prodIp = 'invest.littlebot.online/api'
// 109.61.83.175
// 141.95.45.93
type ProtocolType = 'http' | 'https' | 'ws'

export const generateBaseURL = (port: number, protocol: ProtocolType = 'http', args?: { [key: string]: any }) => {
  const ip = process.env?.REACT_APP_ENV_MODE === 'prod' ? prodIp : process.env?.REACT_APP_ENV_MODE === 'stage' ? stageIp : localhost
  return `${protocol}://${ip}${
    args ? `${Object.values(args).map(([key, value], index) => (index === 0 ? `?${key}=${value}` : `&${key}=${value}`))}` : ''
  }`
}

const calcBotConfig: AxiosRequestConfig = {
  baseURL: generateBaseURL(7777, 'https'),
  headers: { 'Access-Control-Allow-Origin': true },
  timeout: 5000,
}

export const calcInstance: AxiosInstance = axios.create(calcBotConfig)
